import script from "./RgServiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RgServiceCard.vue?vue&type=script&setup=true&lang=js"

import "./RgServiceCard.vue?vue&type=style&index=0&id=b379eeb4&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b379eeb4"]])

export default __exports__